import { render, staticRenderFns } from "./MobileOneItem.vue?vue&type=template&id=60b43cdc&scoped=true&"
import script from "./MobileOneItem.vue?vue&type=script&lang=ts&"
export * from "./MobileOneItem.vue?vue&type=script&lang=ts&"
import style0 from "./MobileOneItem.vue?vue&type=style&index=0&id=60b43cdc&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b43cdc",
  null
  
)

export default component.exports